import { extendTheme } from "@chakra-ui/react";

const deployKey = window.location.pathname.match(
  /\/itpi\/(?:test\/|preview\/)?(.*?)(?:\/|$)/
);
const localStoragePrefix = deployKey ? deployKey[1] : "local";
export const colourModeKey = `${localStoragePrefix}-color-mode`;

const theme = extendTheme({
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },
  colors: {
    lancsRed: {
      50: "#ff5f68",
      100: "#ff7982",
      200: "#ff5f68",
      300: "#e9464f",
      400: "#cf2c35",
      500: "#b6131c",
      600: "#9c0002",
      700: "#830000",
      800: "#690000",
      900: "#500000",
    },
    lancsBlue: {
      50: "#f2f7f9",
      100: "#e6eff3",
      200: "#bfd8e0",
      300: "#99c1cd",
      400: "#4d92a8",
      500: "#006382",
      600: "#005975",
      700: "#004a62",
      800: "#003b4e",
      900: "#003140",
    },
  },
  fonts: {
    heading: "LexiaRegular, sans-serif",
    body: "EffraRegular, sans-serif",
  },
  components: {
    Drawer: {
      variants: {
        alwaysOpen: {
          parts: ["dialog, dialogContainer"],
          dialog: {
            pointerEvents: "auto",
          },
          dialogContainer: {
            pointerEvents: "none",
          },
        },
      },
    },
  },
});

export default theme;
